import React from 'react';
import { CircleCallMeButton, CircleIconButtonWrapper } from './buttonCallMeBackCircleStyle';
import { THEME_COLORS } from '../../styles/theme';
import { Icons } from '../Icons';

import { connect } from "react-redux";
import { callMeBackTrigger } from "../../reducers/callMeBack";

function mapStateToProps(state) {
    return {
        
    }
}

function mapDispatchToProps(dispatch) {
    return {
        toggleCallMeBack: ({ isVisible, submitSuccessTrackName, submitStartTrackName }) => {
            dispatch(callMeBackTrigger({ isVisible, submitSuccessTrackName, submitStartTrackName }))
        }
    }
}

const CallMeBackCircleComponent = (props) => (
    <CircleCallMeButton mainColor={THEME_COLORS.greenBlue} onClick={() => {
        props.toggleCallMeBack({
            submitSuccessTrackName: props.callMeSubmitSuccessTrackName,
            submitStartTrackName: props.callMeSubmitStartTrackName
        });
        props.trackerCallMeClick();
    }}>
        <CircleIconButtonWrapper>
            <Icons icon="CallCenter" color={THEME_COLORS.white} />
        </CircleIconButtonWrapper>
    </CircleCallMeButton>
);

export const CallMeBackCircle = connect(mapStateToProps, mapDispatchToProps)(CallMeBackCircleComponent);